/**
 * Session days: stored in API as comma-separated numbers (1=Mon … 7=Sun).
 * Legacy data may use MON,TUE,… — normalize on read.
 */

const NAME_TO_NUM = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 7,
};

const NUM_TO_SHORT = {
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
  7: "Sun",
};

const NUM_TO_NAME = {
  1: "MON",
  2: "TUE",
  3: "WED",
  4: "THU",
  5: "FRI",
  6: "SAT",
  7: "SUN",
};

/** Parse raw sessionDays string → sorted unique numbers 1–7 */
export function parseSessionDays(raw) {
  if (!raw) return [];
  const nums = new Set();
  String(raw)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((token) => {
      const upper = token.toUpperCase();
      if (NAME_TO_NUM[upper] != null) {
        nums.add(NAME_TO_NUM[upper]);
        return;
      }
      const n = Number(token);
      if (Number.isInteger(n) && n >= 1 && n <= 7) {
        nums.add(n);
      }
    });
  return [...nums].sort((a, b) => a - b);
}

/** Format numbers for API payload: "1,3,5" */
export function formatSessionDays(nums) {
  return parseSessionDays(
    (nums || [])
      .map((n) => String(n))
      .join(",")
  ).join(",");
}

/** Normalize any legacy/raw value to API numeric string */
export function normalizeSessionDaysString(raw) {
  return formatSessionDays(parseSessionDays(raw));
}

export function sessionDaysToShortLabels(raw, t) {
  const days = parseSessionDays(raw);
  if (typeof t === 'function') {
    return days.map((n) => t(`days.short.${n}`, { defaultValue: NUM_TO_SHORT[n] || String(n) }));
  }
  return days.map((n) => NUM_TO_SHORT[n] || String(n));
}

export function sessionDaysToNameLabels(raw) {
  return parseSessionDays(raw).map((n) => NUM_TO_NAME[n] || String(n));
}

export { NUM_TO_SHORT as SESSION_DAY_SHORT };
